import { createBrowserHistory } from "history";
import { userDetail } from "../../config/userDetails";

const history = createBrowserHistory();

export const isAuthorized = () => {
  //if (userDetail().roleName === "FARM_EMPLOYEE") history.goBack();
  return userDetail().roleName !== "FARM_EMPLOYEE";
};

export const isSuperAdmin = () => {
  return userDetail().roleName === "SUPER_ADMIN";
};
export const isCounterParty = () => {
  return userDetail().roleName === "COUNTER_PARTY";
};

export const disableEditRole = (role) => {
  return (role === "SUPER_ADMIN" || role === "ACCOUNT_OWNER")
}
export const hasValidPlan = () => {
  return userDetail().planId !== 1;
};
export const getUserName = () => {
  return userDetail().username
}



// WEBPACK FOOTER //
// ./src/components/Common/CheckAuthorization.js